export default function checkIsMobile() {
  const isClient = typeof window !== 'undefined'
  return !!(isClient ? window.innerWidth < 1200 : undefined)
}
